<template>
  <div id="app">
    <header class="flex" v-if="$route.meta.name!==null">
      <div class="hkj-back" v-if="!$route.meta.showTabBar" @click="$router.go(-1)">返回</div>
      <div class="title">{{ $route.meta.name }}</div>
    </header>
    <router-view class="page-section"></router-view>
    <tab-bar :router="$route" v-if="$route.meta.showTabBar"></tab-bar>
  </div>
</template>

<script>
// import Weui from 'vue-weui'
import TabBar from './components/footer/TabBar.vue'
// import HkjSvg from '@/components/svg/index.vue'
// console.log( Weui )
export default {
  name: 'App',
  components: { TabBar }
}
</script>
<style>
.page-section{
  background-color: rgba(0, 0, 0, 0.05)!important;
}
header {
  background-color: var(--primary-color);
  height: var(--len50);
  line-height: var(--len50);
  /* font-weight: bold; */
}
.hkj-back{
  color: white;
  font-size: var(--len14);
  position: relative;
  cursor: pointer;
  width: var(--len50);
  text-indent: var(--len20);
}
.hkj-back::before{
  content: '';
  position: absolute;
  cursor: pointer;
  width: var(--len10);
  height: var(--len10);
  transform: rotate(-45deg);
  top: var(--len18);
  left: var(--len8);
  border-left: 1px solid white;
  border-top: 1px solid white;
}
header .title{
  font-size: 1rem;
  text-align: center;
  font-family: '微软雅黑';
  color: white;
  flex: 1;
  text-indent: -1.5625rem;
}
</style>
